module.exports = "https://static.energy5.com/_next/static/images/device-41588c9c430459273170d42fa16f8665.png";